<!-- <ng-container *AppShellRender>
  <div style="width: 100vw; height: 3000px"></div>
</ng-container> -->
<div class="invisible-pc-position" #topPosition></div>

<header class="header">
  <div class="logo-start-page">
    <span class="logo"></span>
    <div class="slogan-wrapper">
      <div class="reserve-in-pharmacies">
        <p class="reserve-text" [innerHTML]="'simpleReserve' | transloco"></p>
        <span class="economy">{{'economProc' | transloco}}</span>
      </div>
    </div>
  </div>
  <div class="mobile">
    <fake-search-btn></fake-search-btn>
  </div>
</header>

<div class="desktop">
  <app-input-search></app-input-search>
</div>
<!-- <ng-container *AppShellNoRender> -->
<main>
<start-page-slider></start-page-slider>
<!-- </ng-container> -->
<div class="desktop">
  <app-start-page-lending-content></app-start-page-lending-content>
</div>

<ng-container *ngIf="lang === 'ru'">
  <article class="article-text">
    <h1 class="title">Поиск лекарств</h1>
    <div [ngClass]="{'change': isVisibleBlockSeoText}">
      <p class="paragraph">
        Самостоятельный поиск лекарств по аптекам – долгое и утомительное занятие.
        С нашим сервисом вы можете быстро проверить наличие в аптеке нужного препарата. Не нужно куда-то ходить или
        вручную просматривать ассортимент каждой интернет-аптеки.
        Используйте доступный каталог, чтобы найти и заказать в Украине лекарства, товары для гигиены и другие
        продукты.
        Найти лекарства <a [routerLink]="getAlphabeticalLink()" class="link-to-alphabetical">по названию
          препарата</a>,
        по заболеванию или другим признакам можно в пару кликов.
      </p>

      <h2 class="title font-weight">Как работает сервис поиска лекарств</h2>
      <p class="paragraph">
        Наш сервис предоставляет онлайн поиск актуальных предложений аптек-партнеров. Вы можете найти нужное
        лекарство:
      </p>
      <ul class="paragraph" style="list-style-type: disc; margin-left: 30px;">
        <li>по названию;</li>
        <li>по составу (подбор дешевых аналогов);</li>
        <li>по производителю;</li>
        <li>по категории.</li>
      </ul>
      <h3 class="title font-weight h3">Функция сравнения цен при поиске лекарств</h3>
      <p class="paragraph">Чтобы сравнить цены в ближайших аптеках и забронировать лекарство по интернету,
        регистрироваться не нужно. Заказать таблетки удобно по дороге до аптеки. Аккаунт пользователя дает доступ к
        истории поиска и покупок, защищает пользовательские данные от потери и открывает защищенный доступ с любого
        устройства.</p>

      <h3 class="title font-weight h3">Поиск проверка цен по карте</h3>
      <p class="paragraph">При поиске наличие товара в аптеках города можно проверить на карте. Чтобы забронировать
        несколько позиций,
        используйте функцию списков. Поиск по спискам помогает быстро сравнить стоимость всех препаратов по назначению
        врача в определенных аптеках. Пополняйте домашнюю аптечку быстро и недорого!</p>

      <p class="paragraph">После выбора препарата можно просмотреть его аналоги. Наш сервис позволяет сравнить состав
        лекарственных
        средств, посмотреть различия в дозировке действующего вещества. Чтобы узнать больше, откройте раздел полной
        информации о позиции после поиска. Для всех аптечных препаратов доступны инструкции для распечатки в PDF.</p>

      <p class="paragraph">Если вы подбираете лекарство без участия врача, проверьте характеристики и
        противопоказания.
        Наш сервис поиска
        лекарств позволяет проверять классификацию препарата, рекомендации по применению. Ряд препаратов рекомендуют
        принимать с осторожностью при вождении или склонности к аллергии. Для широко употребимых препаратов доступна
        секция вопросов и ответов.</p>

      <h2 class="title font-weight">Сервис поиска лекарств предоставляет рекомендации</h2>

      <p class="paragraph">Ничего не забыли? Система поиска подскажет, какие товары часто заказывают вместе с вашим
        лекарством.
        Рекомендации составляются на основе пользовательской активности и даются в пределах одной аптеки.</p>

      <h3 class="title font-weight h3">Рецепт при поиске</h3>

      <p class="paragraph">Обратите внимание, забронировать любые таблетки возможно без рецепта, выкуп же
        осуществляется
        с рецептом. Отдельные препараты, в силу содержащихся веществ, выдаются только по рецепту, возьмите его для
        выкупа заказа.</p>

      <h2 class="title font-weight">Преимущества заказа лекарств на сайте</h2>

      <p class="paragraph">Сравнение цен через интернет &ndash; лучший способ поиска дешевых лекарств. Просмотрите
        одновременно все аптеки
        поблизости, найдите самый удобный вариант. Лекарства по рецепту найдутся мгновенно. Несмотря на наличие аптек
        в
        Украине и множества лекарств в них, украинские покупатели сталкиваются с дефицитом популярных рецептурных
        препаратов. Наш сервис поиска находит варианты неподалеку от дома за пару секунд.</p>

      <h3 class="title font-weight h3">Отличия цен препаратов при поиске</h3>

      <p class="paragraph">Стоимость заказа не меняется. Если пользователю удалось заказать нужный препарат, в срок
        действия брони его цена не увеличится. Это сокращает траты и помогает точнее планировать расходы. Если
        заказывать таблетки онлайн - цена может оказаться ниже.</p>

      <h3 class="title font-weight h3">Партнеры сервиса поиска</h3>

      <p class="paragraph">Партнеры с безупречной репутацией. Мы учитываем отзывы посетителей нашего сайта и
        сотрудничаем исключительно с
        аптеками, которые доказали свою благонадежность. Получайте заказы вовремя, в полном составе, по фиксированной
        цене.</p>
      <p class="paragraph">Сайт поиска предлагает специальные скидки. Наши партнеры дают пользователям сервиса
        возможность купить
        некоторые товары дешевле, чем при обычной покупке в розницу. Через обычную интернет-аптеку вы такую скидку
        получить не сможете &ndash; она эксклюзивна для наших клиентов.</p>
      <p class="paragraph">Бронирование экономит время покупателя. Любая точка продажи может оказаться без популярного
        товара. Сайт поиска
        всегда дает достоверную информацию; некоторые сети отказываются бронировать препараты по телефону. У нас
        информация о наличии и стоимости лекарств доступна 24/7. Резервируйте, выкупайте когда удобно!</p>

      <h2 class="title font-weight">Часто задаваемые вопросы</h2>

      <div itemscope itemtype="https://schema.org/FAQPage">

        <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" style="margin-top: 20px;">
          <div itemprop="name" class="question-title">
            <h3 class="question-h3">Как забрать
              лекарство?</h3>
          </div>
          <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div class="question-answer" itemprop="text">Если вы уже забронировали нужные медицинские препараты,
              ожидайте уведомления о готовности заказа. Затем вы сможете забрать товар из магазина с гарантированным
              сохранением цены. Для этого назовите на кассе код брони из SMS или Viber-уведомления, затем проверьте
              состав заказа.</div>
          </div>
        </div>

        <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" style="margin-top: 20px;">
          <div itemprop="name" class="question-title">
            <h3 class="question-h3">Как оплатить заказ?</h3>
          </div>
          <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div class="question-answer" itemprop="text">Оплачивайте товары непосредственно на месте после проверки
              заказа. За бронь ничего платить не нужно.</div>
          </div>
        </div>

        <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" style="margin-top: 20px;">
          <div itemprop="name" class="question-title">
            <h3 class="question-h3">Сколько времени
              действует бронирование лекарств?</h3>
          </div>
          <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div class="question-answer" itemprop="text">Бронь действует от 24 до 72 часов после отправки сообщения с
              подтверждением заявки. Максимальный срок ожидания каждая аптека устанавливает самостоятельно. Если нужно
              дождаться доставки от склада, время будет рассчитано так, чтобы заказ был доступен к моменту выкупа.
            </div>
          </div>
        </div>

        <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" style="margin-top: 20px;">
          <div itemprop="name" class="question-title">
            <h3 class="question-h3">Есть ли доставка
              заказов на дом?</h3>
          </div>
          <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div class="question-answer" itemprop="text">Наш сервис не предлагает услуги доставки медикаментов и
              других
              товаров. Если аптека позволяет забронировать лекарство с доставкой, об этом будет указано на этапе
              оформления брони.</div>
          </div>
        </div>
      </div>
    </div>
    <div (click)="switchSeoBlock()" class="btn-switch-block-text">
      <span class="btn">{{isVisibleBlockSeoText ? ('showMore' | transloco) : ('hide' | transloco)}}</span>
    </div>

  </article>
</ng-container>

<ng-container *ngIf="lang === 'ua'">
  <article class="article-text">
    <h1 class="title">Пошук ліків</h1>
    <div [ngClass]="{'change': isVisibleBlockSeoText}">
      <p class="paragraph">
        Самостійний пошук ліків в аптеках – довге і стомлююче заняття.
        З нашим сервісом можна швидко перевірити наявність в аптеці потрібного препарату.
        Не потрібно кудись ходити чи вручну переглядати асортименти кожної інтернет-аптеки.
        Використовуйте доступний каталог, щоб знайти та замовити в Україні ліки, товари для гігієни та іншу продукцію.
        Знайти ліки <a [routerLink]="getAlphabeticalLink()" class="link-to-alphabetical">за назвою препарату</a>,
        захворюванням або іншими ознаками можна в пару кліків.
      </p>

      <h2 class="title font-weight">Як працює сервіс пошуку ліків</h2>
      <p class="paragraph">
        Наш сервіс надає онлайн пошук актуальних пропозицій аптек-партнерів. Ви можете знайти потрібні ліки:
      </p>
      <ul class="paragraph" style="list-style-type: disc; margin-left: 30px;">
        <li>за назвою;</li>
        <li>за складом (підбір дешевих аналогів);</li>
        <li>за виробником;</li>
        <li>за категорією.</li>
      </ul>
      <h3 class="title font-weight h3">Функція порівняння цін під час пошуку ліків</h3>
      <p class="paragraph">Щоб порівняти ціни в найближчих аптеках та забронювати ліки через інтернет,
        реєструватися не потрібно. Замовити таблетки зручно дорогою до аптеки. Обліковий запис користувача дає доступ
        до
        історії пошуку та покупок, захищає дані користувача від втрати і відкриває захищений доступ з будь-якого
        пристрої.</p>

      <h3 class="title font-weight h3">Пошук, перевірка цін по карті</h3>
      <p class="paragraph">При пошуку наявність товару в аптеках міста можна перевірити на мапі. Щоб забронювати
        кілька позицій, використовуйте функцію списку. Пошук за списком допомагає швидко порівняти вартість всіх
        препаратів за призначенням лікаря у певних аптеках. Поповнюйте домашню аптечку швидко та недорого!</p>

      <p class="paragraph">Після вибору препарату можна переглянути його аналоги. Наш сервіс дозволяє порівняти склад
        лікарських засобів, подивитися відмінності у дозуванні діючої речовини. Щоб дізнатися більше, відкрийте повний
        розділ
        інформації про позицію після пошуку. Для всіх ліків доступні інструкції для друку в PDF.</p>

      <p class="paragraph">Якщо ви підбираєте ліки без участі лікаря, перевірте характеристики та протипоказання.
        Наш сервіс пошуку ліків дозволяє перевіряти класифікацію препарату, рекомендації щодо застосування.
        Ряд препаратів рекомендують приймати з обережністю при керуванні або схильності до алергії.
        Для широко вживаних препаратів доступна секція питань та відповідей.</p>

      <h2 class="title font-weight">Сервіс пошуку ліків надає рекомендації</h2>

      <p class="paragraph">Нічого не забули? Система пошуку підкаже, які товари часто замовляють разом із вашим
        ліками. Рекомендації складаються на основі активності користувача і даються в межах однієї аптеки.</p>

      <h3 class="title font-weight h3">Рецепт при пошуку</h3>

      <p class="paragraph">Зверніть увагу, забронювати будь-які таблетки можливо без рецепта, а викуп здійснюється
        з рецептом. Окремі препарати, в силу речовин, що містяться, видаються тільки за рецептом, візьміть його для
        викупу замовлення.</p>

      <h2 class="title font-weight">Переваги замовлення ліків на сайті</h2>

      <p class="paragraph">Порівняння цін через інтернет &ndash; найкращий спосіб пошуку дешевих ліків. Перегляньте
        одночасно всі аптеки поблизу, знайдіть найзручніший варіант. Ліки за рецептом знайдуться миттєво.
        Незважаючи на наявність аптек в Україні та безлічі ліків у них, українські покупці стикаються з дефіцитом
        популярних рецептурних препаратів. Наш сервіс пошуку знаходить варіанти неподалік дому за пару секунд.</p>

      <h3 class="title font-weight h3">Відмінності цін препаратів під час пошуку</h3>

      <p class="paragraph">Вартість замовлення не змінюється. Якщо користувачу вдалося замовити потрібний препарат,
        під час дії броні його ціна не збільшиться. Це скорочує витрати та допомагає точніше планувати витрати. Якщо
        замовляти таблетки онлайн – ціна може виявитися нижче.</p>

      <h3 class="title font-weight h3">Партнери сервісу пошуку</h3>

      <p class="paragraph">Партнери із бездоганною репутацією. Ми враховуємо відгуки відвідувачів нашого сайту та
        співпрацюємо виключно з аптеками, які довели свою надійність. Отримуйте замовлення вчасно, у повному складі,
        за фіксованою ціною.</p>
      <p class="paragraph">Сайт пошуку пропонує спеціальні знижки. Наші партнери дають користувачам сервісу
        можливість купити деякі товари дешевші, ніж при звичайній покупці в роздріб. Через звичайну інтернет-аптеку ви
        таку знижку
        отримати не зможете &ndash; вона є ексклюзивною для наших клієнтів.</p>
      <p class="paragraph">Бронювання заощаджує час покупця. Будь-яка точка продажу може виявитися без популярного
        товару. Сайт пошуку завжди надає достовірну інформацію; деякі мережі відмовляються бронювати препарати
        телефоном. У нас
        інформація про наявність та вартість ліків доступна 24/7. Резервуйте, викупайте коли зручно!</p>

      <h2 class="title font-weight">Часті питання</h2>

      <div itemscope itemtype="https://schema.org/FAQPage">

        <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" style="margin-top: 20px;">
          <div itemprop="name" class="question-title">
            <h3 class="question-h3">Як забрати
              ліки?</h3>
          </div>
          <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div class="question-answer" itemprop="text">Якщо ви вже забронювали потрібні медичні препарати,
              чекайте на повідомлення про готовність замовлення. Потім ви зможете забрати товар із аптеки з
              гарантованим
              збереженням ціни. Для цього назвіть на касі код броні з SMS або Viber-повідомлення, а потім перевірте
              склад замовлення.</div>
          </div>
        </div>

        <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" style="margin-top: 20px;">
          <div itemprop="name" class="question-title">
            <h3 class="question-h3">Як сплатити замовлення?</h3>
          </div>
          <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div class="question-answer" itemprop="text">Оплачуйте товари безпосередньо на місці після перевірки
              замовлення. За броню нічого платити не треба.</div>
          </div>
        </div>

        <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" style="margin-top: 20px;">
          <div itemprop="name" class="question-title">
            <h3 class="question-h3">Скільки часу
              діє бронювання ліків?</h3>
          </div>
          <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div class="question-answer" itemprop="text">Бронь діє від 24 до 72 годин після відправлення повідомлення
              з
              підтвердженням заявки. Максимальний термін очікування кожна аптека встановлює самостійно. Якщо потрібно
              дочекатися доставки від складу, час буде розрахований так, щоб замовлення було доступне на момент
              викупу.</div>
          </div>
        </div>

        <div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" style="margin-top: 20px;">
          <div itemprop="name" class="question-title">
            <h3 class="question-h3">Чи є доставка
              замовлень додому?</h3>
          </div>
          <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div class="question-answer" itemprop="text">Наш сервіс не пропонує послуги доставки медикаментів та інших
              товарів. Якщо аптека дозволяє забронювати ліки з доставкою, про це буде вказано на етапі
              оформлення броні</div>
          </div>
        </div>
      </div>
    </div>
    <div (click)="switchSeoBlock()" class="btn-switch-block-text">
      <span class="btn">{{isVisibleBlockSeoText ? ('showMore' | transloco) : ('hide' | transloco)}}</span>
    </div>

  </article>
</ng-container>

<div class="alphabetical-wrapper">
  <h2>{{ 'alphabetical' | transloco }}</h2>

  <nav>
    <div class="seleсt-type">
      <button [ngClass]="{'active-type' : activeType === 0 }" class="btn" (click)="setActiveType(0)">АБВ</button>
      <button [ngClass]="{'active-type' : activeType === 1 }" class="btn" (click)="setActiveType(1)">ABC</button>
    </div>

    <div class="latters">
      <div class="latters-wrapper" [ngClass]="{'visable' : activeType === 0 }">
        <ng-container *ngFor="let latter of cyrillicLatters">
          <a class="letter" [routerLink]="getAlphabeticalLink()" [queryParams]="{symbol: latter}">{{ latter }}</a>
        </ng-container>
      </div>

      <div class="latters-wrapper" [ngClass]="{'visable' : activeType === 1 }">
        <ng-container *ngFor="let latter of latinLatters">
          <a class="letter" [routerLink]="getAlphabeticalLink()" [queryParams]="{symbol: latter}">{{ latter }}</a>
        </ng-container>
      </div>
    </div>
  </nav>
</div>
</main>

<bz-static-footer [showCopyright]="true"></bz-static-footer>

<button class="btnToTop" [ngClass]="{'showBtn' : showScrollBtn}" type="button" (click)="scrollToTop()">
  <span class="icon">ffff</span>
</button>